@if (this.loadingSrv.isLoading | async) {
<app-spinner class="fixed inset-0 z-50"> </app-spinner>
} @if (this.isLogged && this.currentRoute !== '/cuota/publica') {
<app-base-layout />
<app-alert />
} @if(!this.isLogged || this.currentRoute === '/cuota/publica') {
<router-outlet />
<app-alert />
}
